import {
  createThemes,
  DEFAULT_PALETTE,
  DEFAULT_SUBDUED_PALETTE,
} from '@bsky.app/alf'

/**
 * ClearCommunity brand blue ramp, generated from the brand color
 * (`primary_500`) using the same tint/shade ratios as the upstream default
 * palette so all three themes (light, dark, dim) share this exact blue.
 */
const BRAND_PRIMARY = {
  primary_25: '#F7FAFD',
  primary_50: '#E9F2F9',
  primary_100: '#D3E5F4',
  primary_200: '#B4D3EC',
  primary_300: '#89B9E0',
  primary_400: '#5D9FD5',
  primary_500: '#247DC6',
  primary_600: '#1E69A6',
  primary_700: '#185586',
  primary_800: '#13436B',
  primary_900: '#0E2F4B',
  primary_950: '#0A2337',
  primary_975: '#071927',
}

const BRAND_PALETTE = {...DEFAULT_PALETTE, ...BRAND_PRIMARY}
const BRAND_SUBDUED_PALETTE = {...DEFAULT_SUBDUED_PALETTE, ...BRAND_PRIMARY}

const DEFAULT_THEMES = createThemes({
  defaultPalette: BRAND_PALETTE,
  subduedPalette: BRAND_SUBDUED_PALETTE,
})

export const themes = {
  lightPalette: DEFAULT_THEMES.light.palette,
  darkPalette: DEFAULT_THEMES.dark.palette,
  dimPalette: DEFAULT_THEMES.dim.palette,
  light: DEFAULT_THEMES.light,
  dark: DEFAULT_THEMES.dark,
  dim: DEFAULT_THEMES.dim,
}

/**
 * @deprecated use ALF and access palette from `useTheme()`
 */
export const lightPalette = DEFAULT_THEMES.light.palette
/**
 * @deprecated use ALF and access palette from `useTheme()`
 */
export const darkPalette = DEFAULT_THEMES.dark.palette
/**
 * @deprecated use ALF and access palette from `useTheme()`
 */
export const dimPalette = DEFAULT_THEMES.dim.palette
/**
 * @deprecated use ALF and access theme from `useTheme()`
 */
export const light = DEFAULT_THEMES.light
/**
 * @deprecated use ALF and access theme from `useTheme()`
 */
export const dark = DEFAULT_THEMES.dark
/**
 * @deprecated use ALF and access theme from `useTheme()`
 */
export const dim = DEFAULT_THEMES.dim
